/**
 * Tools view — landing page for the Tools tab.
 *
 * Currently hosts a single tool: the Fee Calculator. Structured so a
 * second tool can be added by introducing a tool picker without
 * reshaping the layout. Both adviser and assistant see this view
 * identically — role gating (Settings vs Tools) happens at the
 * router level, not here.
 */

import React from 'react';
import { Wrench } from 'lucide-react';
import FeeCalculator from '../components/tools/feeCalculator';

export default function Tools() {
  return (
    <div>
      <h2 style={styles.title}>
        <Wrench size={20} /> Tools
      </h2>
      <p style={styles.subtitle}>
        Calculators and utilities used during client engagements.
      </p>

      <div style={styles.toolSurface}>
        <FeeCalculator />
      </div>
    </div>
  );
}

const styles = {
  title: {
    display: 'flex',
    alignItems: 'center',
    gap: '0.5rem',
    fontSize: '1.3rem',
    fontWeight: 600,
    marginBottom: '0.25rem',
    color: 'var(--cp-text)',
  },
  subtitle: {
    fontSize: '0.85rem',
    color: '#6B7A8D',
    marginBottom: '1.5rem',
  },
  toolSurface: {
    background: '#FFFFFF',
    border: '1px solid #D0DAE6',
    borderRadius: '12px',
    padding: '2rem',
  },
};
